import * as React from 'react';
import '../styles/InlineWarning.sass';

interface componentProps {
    props?: any
}

export default class InlineWarning extends React.Component<componentProps, {}> {

    public render() {
        return (
            <p className="warning" { ...this.props.props }>
                { this.props.children }
            </p>
        )
    }
}
